import { atom } from 'jotai';
import { oktaAuth } from '~/config/oktaConfig';
import { mapOktaUserToUser } from '~/utils/mapOktaUserToUser';
export const userAtom = atom(async () => {
    const userData = await oktaAuth.getUser();
    const mappedUser = mapOktaUserToUser(userData);
    return mappedUser;
});
